<div>
  <div class="db-first-half">
    <h1 class="mb8" >
      What type of online store<br class="hide-mobile"/> are<br class="show-mobile"/> you creating?
    </h1>
    <h5 class="mb40">
      This helps us guide your experience.
    </h5>

    <div class="ds-input-wrap mb9">
      <h4>
        <span class="ds-input-label mb6">Please select your store type</span>
      </h4>
      <ds-dropdown
        [value]="selectedCompanyType"
        [smallSize]="true"
        [dsDropdownOptions]="storeTypesForView"
        [showDropDown]="false"
        [dsDropdownWithSearchIcon]="true"
        dsDropdownPlaceHolder="Search your store type"
        [dsDropdownSearch]="true"
        [dsDropdownWithArrowIcon]="false"
        (onOptionChoose)="selectStoreType($event)"
        (searchOutside)="searchCategory($event)"
      ></ds-dropdown>
    </div>

  </div>
  <div class="create-ai-assistant-form-view__action-wrap first-step" *ngIf="!!isMobile">

    <button class="ds-btn-black ds-btn-max"
            [ngClass]="{'ds-btn-disabled': !selectedCompanyType}"
            (click)="mobileNext.emit()"><span>Next</span>
    </button>
  </div>
</div>
